import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Construct} from 'classes/construct';
import {environment} from 'environment';

@Injectable()
export class ConstructsDetailsRepository {

  constructor(private http: Http) { }

  public getConstructById(id: number): Observable<Construct> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(`${environment.constructs}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawConstruct: Construct) => {
        return Construct.create(rawConstruct);
      });
  }

  public saveConstruct(construct: Construct): Observable<Construct> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(construct);

    return this.http.post(environment.constructs, body, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawConstruct: Construct) => {
        return Construct.create(rawConstruct);
      });
  }

  public updateConstruct(construct: Construct): Observable<Construct> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(construct);

    return this.http.put(`${environment.constructs}/${construct._id}`, body, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawConstruct: Construct) => {
        return Construct.create(rawConstruct);
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-details/repositories/constructs-details.repository.ts